import './WordMakerHome.css'
import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "../../providers/themeContext/theme-context.tsx";
import {PageEnum, PageProps} from "../../types/IPage.ts";
import SettingModal from "../home/component/SettingModal.tsx";
import PlayTipModal from "../home/component/PlayTipsModal.tsx";
import MyPuzzlesDialog from "./components/MyPuzzlesDialog.tsx";
import {GAEvents} from "../../common/utils/GA4/GAEvents.ts";
import {useMusicContext} from "../../providers/musicProvider/music-player-context.tsx";

const WordMakerHome: React.FC<PageProps> = ({switchPage}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局音乐provider
    const musicManager = useMusicContext();
    // 是否显示游戏提示
    const [showPlayTip, setShowPlayTip] = useState<boolean>(false)
    // 是否弹出设置弹窗
    const [showSetting, setShowSetting] = useState<boolean>(false)
    // 是否弹出 my puzzles 弹窗
    const [showMyPuzzles, setShowMyPuzzles] = useState<boolean>(false)

    useEffect(() => {
        // GA埋点
        GAEvents.wordMakerShow()

    }, []);


    // 打开how to play提示弹窗
    const openHowToPlayModal = () => {
        musicManager.playButtonSound()
        setShowPlayTip(true)
    }

    // 打开设置弹窗
    const openSettingModal = () => {
        musicManager.playButtonSound()
        setShowSetting(true)
    }

    // 返回按钮的点击事件
    const handleBackButton = () => {
        musicManager.playButtonSound()
        // 游戏开始按钮的点击事件
        switchPage(PageEnum.HOME)
    }

    // 在设置中点击游戏提示
    const showPlayTipModal = () => {
        musicManager.playButtonSound()
        // 关闭设置弹窗
        setShowSetting(false)
        // 显示游戏提示
        setShowPlayTip(true)
    }

    // 打开 my puzzles 弹窗
    const openMyPuzzlesModal = () => {
        // GA埋点
        GAEvents.wordMakerClick("Create")
        musicManager.playButtonSound()
        setShowMyPuzzles(true)
    }

    // 跳转到UGC游戏页面
    const switchToUGCPuzzlePage = () => {
        // GA埋点
        GAEvents.wordMakerClick("Play")
        musicManager.playButtonSound()
        switchPage(PageEnum.UGCGamePage)
    }

    return (
        <div className="home-page">
            <img className="common-embellish-bg-left-top-page" src={imgUrls.leftTopBgUrl} alt="pic"/>
            <img className="common-embellish-bg-right-bottom-page" src={imgUrls.rightBottomBgUrl} alt="pic"/>

            {/*<style>{`body { background-color: #F1F4FF }`}</style>*/}
            <div className="display-flex-column">
                {/*顶部标题栏*/}
                <div className="top-title-container" style={{backgroundImage: `url(${imgUrls.titleBarBgUrl})`}}>
                    <img onClick={handleBackButton} className="go-back-button" src={imgUrls.goBackIconUrl} alt="pic"/>
                    <img onClick={openHowToPlayModal} className="tip-button" src={imgUrls.gameTipIconUrl}
                         alt="pic"/>
                    <img onClick={openSettingModal} className="game-setting-button" src={imgUrls.settingIconUrl}
                         alt="pic"/>
                </div>
            </div>
            {/*顶部图标*/}
            <img className="width-53 height-53 margin-top-63" src={imgUrls.ugcHomeTopIcon} alt="pic"/>
            {/*标题文字*/}
            <div className="my-roboto-bold font-size-21 color-purple margin-top-10">Word Maker</div>
            {/*添加比赛*/}
            <div onClick={openMyPuzzlesModal}
                 className="margin-top-17 common-card-item first-card-bg-color display-flex-row display-flex-align-items-center display-flex-space-between">
                <div className="margin-left-22 display-flex-column margin-right-14">
                    <div className="my-roboto-bold font-size-21 color-white">Create</div>
                    <div className="my-roboto-regular font-size-16 color-white margin-top-6">
                        Create your own puzzle
                    </div>
                </div>
                <img className="margin-right-14 height-40 width-40" src={imgUrls.firstArrowRightIcon} alt="pic"/>
            </div>
            <div onClick={switchToUGCPuzzlePage}
                 className="margin-top-10 common-card-item second-card-bg-color display-flex-row display-flex-align-items-center display-flex-space-between">
                <div className="margin-left-22 display-flex-column margin-right-14">
                    <div className="my-roboto-bold font-size-21 color-white">Play</div>
                    <div className="my-roboto-regular font-size-16 color-white margin-top-6">
                        Play others' puzzles
                    </div>
                </div>
                <img className="margin-right-14 height-40 width-40" src={imgUrls.secondArrowRightIcon} alt="pic"/>
            </div>
            {/*设置的弹窗*/}
            <SettingModal key="homeSettingModal" isOpen={showSetting} onClose={() => setShowSetting(false)}
                          onShowPlayTip={showPlayTipModal}/>
            {/*游戏提示的弹窗*/}
            <PlayTipModal key="playTipModal" isOpen={showPlayTip} onClose={() => setShowPlayTip(false)}/>
            <MyPuzzlesDialog key="myPuzzlesDialog" isOpen={showMyPuzzles} onClose={() => setShowMyPuzzles(false)}/>
        </div>
    )
}

export default WordMakerHome;